export default __webpack_public_path__ + "static/media/Elixir of Precision.a0695f58.jpg";